export default {
  container: {
    position: 'relative'
  },
  message: {
    color: '#bbb',
    margin: '28px 0 0',
    padding: '0 50px',
    textAlign: 'center'
  },
  pendingOverlay: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}
